module.exports = __webpack_public_path__ + "img/home_side_bar.a09a48a9.png";